var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { dia, shapes } from '@joint/plus';
var Node = /** @class */ (function (_super) {
    __extends(Node, _super);
    function Node() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'rect',
                selector: 'body',
            }, {
                tagName: 'text',
                selector: 'label',
            }];
        return _this;
    }
    Node.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'app.Node', z: 100, size: {
                width: 120,
                height: 40
            }, attrs: {
                root: {
                    pointerEvents: 'none'
                },
                body: {
                    width: 'calc(w)',
                    height: 'calc(h)',
                    fill: '#FFFFFF',
                    stroke: '#A0A0A0',
                },
                label: {
                    x: 'calc(0.5 * w)',
                    y: 'calc(0.5 * h)',
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    fontSize: 14
                },
            } });
    };
    Node.prototype.setText = function (text) {
        return this.attr('label/text', text || '');
    };
    return Node;
}(dia.Element));
export { Node };
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'path',
                selector: 'wrapper',
                attributes: {
                    'fill': 'none',
                    'stroke': 'transparent'
                }
            }, {
                tagName: 'path',
                selector: 'line',
                attributes: {
                    'fill': 'none',
                }
            }];
        return _this;
    }
    Link.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'app.Link', z: 101, attrs: {
                root: {
                    pointerEvents: 'none'
                },
                line: {
                    connection: true,
                    stroke: '#A0A0A0',
                    strokeWidth: 1,
                },
                wrapper: {
                    connection: true,
                    strokeWidth: 10,
                    strokeLinejoin: 'round'
                }
            } });
    };
    Link.prototype.connect = function (sourceId, targetId) {
        return this.set({
            source: { id: sourceId },
            target: { id: targetId }
        });
    };
    return Link;
}(dia.Link));
export { Link };
var Token = /** @class */ (function (_super) {
    __extends(Token, _super);
    function Token() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.markup = [{
                tagName: 'rect',
                selector: 'body',
                attributes: {
                    'cursor': 'pointer',
                }
            }, {
                tagName: 'text',
                selector: 'label',
                attributes: {
                    'cursor': 'pointer',
                }
            }];
        return _this;
    }
    Token.prototype.defaults = function () {
        return __assign(__assign({}, _super.prototype.defaults), { type: 'app.Token', z: 102, size: { width: 24, height: 16 }, position: { x: 250, y: 10 }, hidden: true, attrs: {
                body: {
                    width: 'calc(w)',
                    height: 'calc(h)',
                    fill: '#FFFFFF',
                    stroke: '#A0A0A0',
                    strokeWidth: 1
                },
                label: {
                    x: 'calc(0.5 * w)',
                    y: 'calc(0.5 * h)',
                    textAnchor: 'middle',
                    textVerticalAnchor: 'middle',
                    fontSize: 14,
                    fill: '#303740'
                },
            } });
    };
    Token.prototype.setText = function (text) {
        return this.attr('label/text', text || '');
    };
    return Token;
}(dia.Element));
export { Token };
export var cellNamespace = __assign(__assign({}, shapes), { app: {
        Node: Node,
        Link: Link,
        Token: Token
    } });
